import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement,
    deleteElement
} from './common';
import {
    CALL_API
} from 'redux-api-middleware';


const apiUrl = '/api/partners';

export function submitPartner(values) {
    return submitElement(apiUrl, values, types.SUBMIT_PARTNER);
}
export function fetchPartner(itemId) {
    return fetchElement(apiUrl, itemId, types.ADMIN_LOAD_PARTNER);
}

export function fetchPartners(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.ADMIN_LOAD_PARTNERS);
}

export function deletePartner(partner) {
    return deleteElement(apiUrl, partner.id, types.DELETE_PARTNER);
}


export function fetchAllPartners() {
    return {
        [CALL_API]: {
            endpoint: apiUrl,
            method: 'GET',
            types: types.LOAD_PARTNERS.all
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/partners.js